import { useContext } from 'react';
import '../style/components/removeItem.css';
import { context } from '../context/context';
export default function RemoveItem(props) {
    const { setDeleteBox } = useContext(context);
    // props mode of remove any item
    return (
        <div className="container-box fixed flex flex-center-center">
            <div className="box remove">
                <h2>Are you sure you want to remove this item?</h2>
                <div className="action">
                    <button className='success-bg'><i className="fa-solid fa-trash"></i> yes</button>
                    <button onClick={() => setDeleteBox(false)} className='error-bg'><i className="fa-solid fa-x"></i> no</button>
                </div>
            </div>
        </div>
    )
}